// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__mD4Ae","unreadBadge":"styles_unreadBadge__ZN3Wr","modalContent":"styles_modalContent__1mbCm","modal":"styles_modal__3PnBa"};